import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import CreateMedical from './CreateMedical'
import MedicalsTable from './MedicalsTable'
import CreateVaccination from './CreateVaccination'
import VaccinationsTable from './VaccinationsTable'

class Medical extends FirebaseComponent {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12"><h4>Medicals</h4></div>
          <div className="col-sm-6"><MedicalsTable/></div>
          <div className="col-sm-6"><CreateMedical/></div>
        </div>
        <div className="row">
          <div className="col-sm-12"><h4>Vaccinations</h4></div>
          <div className="col-sm-6"><VaccinationsTable/></div>
          <div className="col-sm-6"><CreateVaccination/></div>
        </div>
      </div>
    )
  }
}

export default Medical



// WEBPACK FOOTER //
// ./src/Medical.js